import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  clearOnboardingRedirectFlag,
  companyFetchedSelector,
  companyShouldRedirectAfterOnboardingSelector,
  completeCompanyOnboarding,
  createCompany,
  currentCompanySelector,
  fetchCompanyByUserId,
  updateCompany
} from '../../redux/features/company/companiesSlice';
import {
  currentFileSelector,
  isProcessingSelector,
  uploadFile
} from '../../redux/features/file/filesSlice';
import { CompanyOnboardingStepper } from './components';
import { APP_PATH_DASHBOARD } from '../../config';
import { useCurrentUserInfo } from '../../hooks/useCurrentUserInfo';

const CompanyOnboarding = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { user, userId } = useCurrentUserInfo();
  const company = useSelector(currentCompanySelector);
  const currentFile = useSelector(currentFileSelector);
  const isProcessingFile = useSelector(isProcessingSelector);
  const shouldRedirect = useSelector(
    companyShouldRedirectAfterOnboardingSelector
  );
  const companyFetched = useSelector(companyFetchedSelector);

  // Fetch company data when component mounts (only once using Redux flag)
  useEffect(() => {
    // Only attempt to fetch if we haven't fetched yet
    if (userId && !companyFetched) {
      console.log(
        '🔄 [Company Onboarding] Fetching company data for user:',
        userId
      );
      dispatch(fetchCompanyByUserId({ userId }));
    }
  }, [companyFetched, userId, dispatch]);

  // Watch for redirect flag from Redux and redirect
  useEffect(() => {
    if (shouldRedirect) {
      console.log(
        '✅ [Company Onboarding] Onboarding completed, redirecting to dashboard'
      );
      dispatch(clearOnboardingRedirectFlag());
      history.push(APP_PATH_DASHBOARD);
    }
  }, [shouldRedirect, dispatch, history]);

  const handleSave = (data, shouldClose) => {
    console.log('💾 [Company Onboarding] Saving company data');
    try {
      // Check if company exists (has an id)
      if (data.id) {
        // Update existing company
        console.log(
          '🔄 [Company Onboarding] Updating existing company:',
          data.id
        );
        dispatch(updateCompany({ company: data }));
      } else {
        // Create new company
        console.log('✨ [Company Onboarding] Creating new company');
        dispatch(createCompany({ company: data }));
      }

      // If shouldClose is true, mark onboarding as completed
      if (shouldClose) {
        console.log('✅ [Company Onboarding] Completing onboarding');
        dispatch(completeCompanyOnboarding());
        // Redirect will happen via useEffect watching onboarding status
      }
    } catch (error) {
      console.error('❌ [Company Onboarding] Failed to save company:', error);
    }
  };

  const handlePhotoUpload = (file) => {
    console.log('📸 [Company Onboarding] Uploading company logo:', file.name);
    dispatch(uploadFile({ file }));
  };

  const userName =
    user?.fullName || user?.full_name || user?.email || 'Company';
  const logoUrl = currentFile?.publicUrl;

  return (
    <CompanyOnboardingStepper
      onSave={handleSave}
      initialData={company || {}}
      loading={isProcessingFile}
      logoUrl={logoUrl}
      onLogoUpload={handlePhotoUpload}
      userName={userName}
    />
  );
};

export default CompanyOnboarding;
